// src/components/SoilCompositionChart.js
import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { Box, Typography } from "@mui/material";

const SoilCompositionChart = ({ data, year }) => {
  if (!year) return null;
  if (!data || data.length === 0) {
    return <Typography>No soil composition data available for {year}.</Typography>;
  }

  // Ensure chronological order
  const sorted = [...data].sort(
    (a, b) => new Date(a.timestamp) - new Date(b.timestamp)
  );

  const makeSeries = (name, color, key, width = 2, dashStyle = "Solid") => ({
    name,
    data: sorted.map((d) => [new Date(d.timestamp).getTime(), d[key]]),
    color,
    lineWidth: width,
    dashStyle,
    marker: { enabled: true, radius: 3 },
  });

  const options = {
    chart: {
      type: "line",
      height: 250,
      zoomType: "x",
    },
    title: {
      text: `Soil Composition – ${year}`,
    },
    xAxis: {
      type: "datetime",
      min: new Date(`${year}-01-01`).getTime(),
      max: new Date(`${year}-12-31`).getTime(),
      labels: {
        format: "{value:%b}", // Jan, Feb, ...
      },
      tickInterval: 30 * 24 * 3600 * 1000, // monthly ticks
    },
    yAxis: {
      title: { text: "Value" },
      allowDecimals: true,
      min: null, // auto, can dip below 0
    },
    tooltip: {
      xDateFormat: "%b %Y",
      shared: true,
    },
    legend: {
      enabled: true,
      align: "right",
      verticalAlign: "middle",
      layout: "vertical",
    },
    series: [
      // Bold solid score line
      makeSeries("Soil Score", "#000000", "score", 4, "Solid"),

      // Nutrients as dotted lines
      makeSeries("Nitrogen", "#4caf50", "nitrogen", 2, "Dot"),
      makeSeries("Phosphorus", "#2196f3", "phosphorus", 2, "Dot"),
      makeSeries("Potassium", "#ff9800", "potassium", 2, "Dot"),
      makeSeries("Organic Matter", "#9c27b0", "organic_matter", 2, "Dot"),
    ],
    responsive: {
      rules: [
        {
          condition: { maxWidth: 600 },
          chartOptions: {
            legend: {
              layout: "horizontal",
              align: "center",
              verticalAlign: "bottom",
            },
          },
        },
      ],
    },
  };

  return (
    <Box sx={{ my: 4 }}>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </Box>
  );
};

export default SoilCompositionChart;
